import {Box, Skeleton, Typography} from "@mui/material";
import {COLORS} from "../configs/config";
import {useAppContext} from "../../../../../contexts/AppContext";
import {AssessmentOutlined, CategoryOutlined, DevicesOutlined, NotificationsActiveOutlined} from "@mui/icons-material";

export const BannerMetrics = ({ data, loading, isAdmin }) => {
    const nums = [
        { label: 'Retiradas', val: data?.retiradasRequisicoes?.totalRetiradas ?? 0, warn: false },
        { label: 'Requisições', val: data?.retiradasRequisicoes?.totalRequisicoes ?? 0, warn: false },
        { label: 'Total', val: data?.retiradasRequisicoes?.total ?? 0, warn: false },
        // { label: 'Alertas', val: data?.alertas?.total ?? 0, warn: (data?.alertas?.total ?? 0) > 0 },
        // { label: 'Funcionários', val: data?.dadosEmpresa?.pessoas ?? 0, warn: false },
    ];

    return (
        <Box sx={{
            bgcolor: COLORS.bannerBg,
            borderRadius: 3,
            p: '18px 22px',
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            alignItems: 'center',
            gap: 2
        }}>
            <Box>
                {isAdmin && (
                    <Typography
                        variant="caption"
                        sx={{
                            color: COLORS.bannerText,
                            display: 'block',
                            mb: 0.5
                        }}
                    >
                        Resumo operacional
                    </Typography>
                )}

                <Typography
                    variant="body1"
                    sx={{ color: "#FFF", fontWeight: 500 }}
                >
                    Bem-vindo(a), {useAppContext().dadosUsuario?.pessoa?.nome}
                </Typography>

                <Typography
                    variant="caption"
                    sx={{ color: COLORS.bannerText }}
                >
                    {useAppContext().dadosUsuario?.pessoa?.empresa?.nome}
                </Typography>
            </Box>

            {isAdmin && (
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                    {nums.map((n, i) => (
                        <Box key={i} sx={{ textAlign: 'center' }}>
                            {loading
                                ? <Skeleton variant="text" width={40} sx={{ bgcolor: 'rgba(255,255,255,.15)', mx: 'auto' }} />
                                : <Typography variant="h6" sx={{ color: n.warn ? '#FAC775' : '#fff', fontWeight: 500, lineHeight: 1 }}>
                                    {n.val.toLocaleString('pt-BR')}
                                </Typography>
                            }
                            <Typography variant="caption" sx={{ color: COLORS.bannerText, fontSize: 10 }}>
                                {n.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
}

export const AlertRow = ({ label, valor, tipo = 'ok' }) => {
    const colors = {
        ok: { dot: COLORS.g3, num: COLORS.g1 },
        warn: { dot: '#EF9F27', num: COLORS.amber },
        danger: { dot: '#E24B4A', num: COLORS.red },
    };

    const c = colors[tipo];

    return (
        <Box sx={{
            display: 'flex', alignItems: 'center', gap: 1, py: 0.75,
            borderBottom: `0.5px solid ${COLORS.border}`,
            '&:last-child': { borderBottom: 'none', pb: 0 },
        }}>
            <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: c.dot, flexShrink: 0 }} />
            <Typography variant="caption" sx={{ color: COLORS.tDim, flex: 1 }}>{label}</Typography>
            <Typography variant="caption" sx={{ color: c.num, fontWeight: 700 }}>{valor}</Typography>
        </Box>
    );
};

export const InfoRow = ({ icon, label }) => (
    <Box sx={{
        display: 'flex', alignItems: 'center', gap: 1, py: 0.75,
        borderBottom: `0.5px solid ${COLORS.border}`,
        '&:last-child': { borderBottom: 'none' },
    }}>
        <Box sx={{ color: COLORS.g2, display: 'flex', fontSize: 16 }}>{icon}</Box>

        <Typography variant="caption" sx={{ color: COLORS.tDim }}>{label}</Typography>
    </Box>
);

export const DashCard = ({ title, children, sx = {}, data }) => (
    <Box sx={{
        bgcolor: COLORS.card, border: `0.5px solid ${COLORS.border}`,
        borderRadius: 3, p: 2, height: '100%', ...sx,
    }}>
        {title && (
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.25}>
                <Typography variant="caption" sx={{
                    color: COLORS.tSec, fontWeight: 600,
                    textTransform: 'uppercase', letterSpacing: '.04em', fontSize: 10,
                }}>
                    {title}
                </Typography>

                {data !== undefined && (
                    <Typography variant="caption" sx={{
                        color: COLORS.tDim, fontWeight: 600, fontSize: 10,
                        bgcolor: COLORS.kpiBg, borderRadius: 10, px: 1, py: 0.25,
                    }}>
                        {data}
                    </Typography>
                )}
            </Box>
        )}
        {children}
    </Box>
);

export const MODULE_LIST = [
    { rota: "equipamento", title: 'Cadastro de Equipamentos', desc: 'Gerencie os equipamentos das empresas.', url: '/epis/equipamentos', color: COLORS.kpiBg, iconColor: COLORS.g1, icon: <DevicesOutlined fontSize="small" /> },
    { rota: "alertas", title: 'Alertas Disparados',  desc: 'Visualize os alertas que foram disparados.', url: '/epis/alertas/lista_alertas', color: '#FDF8EC', iconColor: COLORS.amber, icon: <NotificationsActiveOutlined fontSize="small" /> },
    { rota: "produtos", title: 'Cadastro de Produtos', desc: 'Cadastre e gerencie EPIs com facilidade.', url: '/epis/produtos',  color: COLORS.kpiBg, iconColor: COLORS.g1, icon: <CategoryOutlined fontSize="small" /> },
    { rota: "relatorios", title: 'Relatórios Ficha EPI', desc: 'Visualize relatórios de fichas de EPI.',  url: '/epis/relatorios', color: '#EBF3FB', iconColor: '#185FA5', icon: <AssessmentOutlined fontSize="small" /> },
];

export const ModuleCard = ({ title, desc, url, color, iconColor, icon }) => (
    <Box
        component="a"
        href={url}
        sx={{
            display: 'flex', alignItems: 'center', gap: 1.5,
            bgcolor: COLORS.card, border: `0.5px solid ${COLORS.border}`,
            borderRadius: 3, p: '12px 14px', textDecoration: 'none',
            transition: 'border-color .15s',
            '&:hover': { borderColor: COLORS.g2 },
            height: '10vh'
        }}
    >
        <Box sx={{
            width: 38, height: 38, borderRadius: 2,
            bgcolor: color, display: 'grid', placeItems: 'center',
            color: iconColor, flexShrink: 0,
        }}>
            {icon}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" sx={{ color: COLORS.tSec, fontWeight: 500, lineHeight: 1.3 }}>
                {title}
            </Typography>

            <Typography variant="caption" sx={{ color: COLORS.tDim, display: 'block', mt: 0.25, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {desc}
            </Typography>
        </Box>
        <Box sx={{ color: COLORS.g3, fontSize: 18 }}>›</Box>
    </Box>
);
